import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Customer from "../interfaces/customer/customer";

/* ---------------- TYPES ---------------- */

export interface UserData {
  name: string;
  email: string;
}
export interface customerInfoType {
  selectedSite: {
    name: string;
    code: string;
    cameraSiteId: string;
    lastSurveyDate: string;
    nextSurveyDate: string;
    latitude: string;
    longitude: string;
  } | null;

  selectedCustomer: {
    name: string;
    code: string;
    customerId: string;
  } | null;

  lastSurveyDate: string | null;
  nextSurveyDate: string | null;
  cameraSiteId: string | null;
}

export interface AuraCameraCommonState {
  CustData: Customer[];
  userInfo: any[];
  SiteData: any[];
  StackedBarGraphHeight: boolean;
  setMapHeightPanel: boolean;
  setEmissionBySizeHeightPanel: boolean;
  setSurveyCompStatusHeightPanel: boolean;
  appendSitesData: string;
  isAuth: boolean;
  userData: UserData;
  leakedSites: any[];
  clickedSiteObj: any;
  selectedCustomerInfo: customerInfoType; 
}

/* ---------------- INITIAL STATE ---------------- */

const initialState: AuraCameraCommonState = {
  CustData: [],
  userInfo: [],
  SiteData: [],
  StackedBarGraphHeight: false,
  setMapHeightPanel: false,
  setEmissionBySizeHeightPanel: false,
  setSurveyCompStatusHeightPanel: false,
  appendSitesData: "",
  isAuth: false,
  userData: {
    name: "",
    email: "",
  },
  leakedSites: [],
  clickedSiteObj: {},
  selectedCustomerInfo: {                
    selectedSite: null,
    selectedCustomer: null,
    lastSurveyDate: null,
    nextSurveyDate: null,
    cameraSiteId: null,
  },
};

/* ---------------- SLICE ---------------- */

const AuraCameraCommon = createSlice({
  name: "AuraCameraCommon",
  initialState,
  reducers: {
    addCustomersData(
      state,
      action: PayloadAction<Customer[]>
    ) {
      const allIndex = action.payload.findIndex(
        (x) => x.name === "All"
      );

      if (allIndex !== -1) {
        action.payload[allIndex].name = "All Customers";
        action.payload.shift(); // remove "All"
      }

      state.CustData = action.payload;
    },

    addUser(
      state,
      action: PayloadAction<any[]>
    ) {
      state.userInfo = action.payload;
    },

    setSitesData(
      state,
      action: PayloadAction<any[]>
    ) {
      state.SiteData = action.payload;
    },

    appendSitesData(
      state,
      action: PayloadAction<any[]>
    ) {
      state.SiteData = action.payload;
    },

    SetUserAuth(
      state,
      action: PayloadAction<UserData>
    ) {
      state.isAuth = true;
      state.userData = action.payload;
    },

    logout(state) {
      state.isAuth = false;
      state.userData = {
        name: "",
        email: "",
      };
    },

    setSurveyEmissionStackGraph(
      state,
      action: PayloadAction<boolean>
    ) {
      state.StackedBarGraphHeight = action.payload;
    },

    setMapHeightPanel(
      state,
      action: PayloadAction<boolean>
    ) {
      state.setMapHeightPanel = action.payload;
    },

    setEmissionBySizeHeightPanel(
      state,
      action: PayloadAction<boolean>
    ) {
      state.setEmissionBySizeHeightPanel = action.payload;
    },

    setSurveyCompStatusHeightPanel(
      state,
      action: PayloadAction<boolean>
    ) {
      state.setSurveyCompStatusHeightPanel = action.payload;
    },

    setLeakedSites(
      state,
      action: PayloadAction<any[]>
    ) {
      state.leakedSites = action.payload;
    },

    setClickedSiteObj(
      state,
      action: PayloadAction<any>
    ) {
      state.clickedSiteObj = action.payload;
    },
    setSelectedCustomerInfo(
      state,
      action: PayloadAction<customerInfoType>
    ) {
      state.selectedCustomerInfo = action.payload;
    },
  },

});

/* ---------------- EXPORTS ---------------- */

export const {
  addCustomersData,
  setSitesData,
  addUser,
  SetUserAuth,
  logout,
  appendSitesData,
  setSurveyEmissionStackGraph,
  setMapHeightPanel,
  setEmissionBySizeHeightPanel,
  setSurveyCompStatusHeightPanel,
  setLeakedSites,
  setClickedSiteObj,
  setSelectedCustomerInfo,
} = AuraCameraCommon.actions;

export default AuraCameraCommon.reducer;

